export const MATHQUILL_FORMULA_OPERATORS = [
    ['{x}^{n}', '{x}^{}'],
    ['{x}_{i}', '{x}_{}'],
    ['\\sqrt{x}', '\\sqrt'],
    ['\\sqrt[3]{x}', '\\sqrt[3]{}'],
    ['\\sqrt[n]{x}', '\\nthroot'],
    ['\\frac{x}{y}', '\\frac'],
    ['\\pi', '\\pi'],               // PI
    ['\\theta', '\\theta'],
    ['\\degree', '\\degree'],      // Degree
    ['\\Delta', '\\Delta'],    
    
    ['\\sum^{0}_{n}{x}', '\\sum'],
    ['\\prod^{s}_{x}{d}', '\\prod'],
    ['\\coprod^{s}_{x}{d}', '\\coprod'],
    ['\\int^{s}_{x}{}', '\\int'],

    ['\\pm', '\\pm'],
    ['\\times', '\\times'],
    ['\\infty', '\\infty'],        // Infinity
    ['\\partial', '\\partial'],    // Partial derivative

    ['\\in', '\\in'],              // Element of
    ['\\notin', '\\notin'],        // Not an element of
    ['\\cup', '\\cup'],            // Union
    ['\\cap', '\\cap'],            // Intersection
    ['\\forall', '\\forall'],      // For all
    ['\\exists', '\\exists'],      // Exists
    ['\\subset', '\\subset'],      // Subset
    ['\\supset', '\\supset'],      // Superset
    ['\\subseteq', '\\subseteq'],  // Subset or equal
    ['\\supseteq', '\\supseteq'],  // Superset or equal

    ['\\leq', '\\leq'],            // Less than or equal to
    ['\\geq', '\\geq'],            // Greater than or equal to
    ['\\neq', '\\neq'],            // Not equal to
    ['\\approx', '\\approx'],      // Approximately equal to
    ['\\to', '\\to'],              // Tends to (arrow)

    ['\\Leftrightarrow', '\\Leftrightarrow'],  // Left right arrow
    ['\\Rightarrow', '\\Rightarrow'],          // Right arrow
    ['\\Leftarrow', '\\Leftarrow'],            // Left arrow
  ];
